<script setup>
import { useForm } from "@/form";
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

const { t: __ } = useI18n();

const loaded = ref(false);
const videos = ref([]);
const open = ref(false);
const currentVideo = ref();

const thumbnailUrl = (video) => {
    if (video.thumbnail_url) {
        return video.thumbnail_url;
    }
    return "https://img.youtube.com/vi/" + video.video_id + "/maxresdefault.jpg";
};

const showVideo = (video) => {
    currentVideo.value = video;
    open.value = true;
};

onMounted(async () => {
    videos.value = await useForm().post("videos_index");
    loaded.value = true;
});
</script>

<template>
    <div v-if="videos.length > 0">
        <div class="flex justify-between items-center">
            <div class="space-y-1">
                <h2 class="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">{{ __("Dernières vidéos") }}</h2>
                <p class="text-sm text-gray-600 dark:text-gray-400">{{ __("Découvrez les dernières vidéos: news, conseils, guides, tutos...") }}</p>
            </div>
        </div>

        <div class="grid gap-6 mt-6 lg:grid-cols-3 sm:grid-cols-2">
            <div v-for="video in videos" class="flex flex-col">
                <div @click="showVideo(video)" class="aspect-video overflow-hidden relative bg-gray-300 rounded-lg cursor-pointer group dark:bg-gray-800">
                    <img :src="thumbnailUrl(video)" :alt="video.title" class="object-cover duration-1000 pointer-events-none group-hover:scale-105" />
                </div>
                <div v-if="video.title" class="mt-1">
                    <div class="text-base line-clamp-2">{{ video.title }}</div>
                </div>
            </div>
        </div>

        <TransitionRoot as="template" :show="open">
            <Dialog as="div" class="z-[100000] relative" @close="open = false">
                <TransitionChild
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100"
                    leave-to="opacity-0">
                    <div class="bg-black/80 bg-opacity-75 fixed inset-0 transition-opacity" />
                </TransitionChild>

                <div class="z-[100000] overflow-y-auto fixed inset-0">
                    <div class="min-h-full flex justify-center items-end p-4 sm:items-center sm:p-0">
                        <TransitionChild
                            as="template"
                            enter="ease-out duration-300"
                            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enter-to="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leave-from="opacity-100 translate-y-0 sm:scale-100"
                            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                            <DialogPanel class="transform w-full relative bg-black shadow-xl transition-all sm:max-w-3xl sm:my-8">
                                <div class="aspect-video">
                                    <iframe
                                        :src="'https://www.youtube.com/embed/' + currentVideo.video_id + '?autoplay=1'"
                                        width="100%"
                                        height="100%"
                                        :title="currentVideo.title"
                                        frameborder="0"
                                        allowfullscreen></iframe>
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </div>
            </Dialog>
        </TransitionRoot>

        <!-- <Modal ref="modal" class="bg-black rounded-none">
            <div class="bg-black">
                <div class="aspect-video">
                    <iframe
                        :src="'https://www.youtube.com/embed/' + currentVideo.video_id + '?autoplay=1'"
                        width="100%"
                        height="100%"
                        :title="currentVideo.title"
                        frameborder="0"
                        allowfullscreen
                    ></iframe>
                </div>
            </div>
        </Modal> -->
    </div>
</template>
